<template>
  <v-tooltip top class="tooltip-botao-visualizar-propostas">
    <a slot="activator" role="button"
       :class="`botao-visualisar-propostas ${colorClass} ${confirmarDesabilitado}`"
       @click.stop="$emit('eventoVisualizarPropostas')">
        <i class="fas fa-download ma-0" aria-hidden="true"/>
      <span class="ml-1">{{ texto }}</span>
    </a>
    {{mensagemTooltip}}
  </v-tooltip>
</template>

<script>
export default {
    name: 'BotaoVisualizarPropostas',
    props:{
        texto:{
            type: String,
            default: 'Botão'
        },
        colorClass:{
            type: String,
            default: 'secondary-color'
        },
        deshabilitar: {
            type: Boolean,
            default: false
        },
        mensagemTooltip: {
            type: String,
            default: ''
        }
    },
    computed:{
        confirmarDesabilitado() {
            return this.deshabilitar ? 'deshabilitado' : 'habilitado'
        }
    }
}
</script>

<style scoped lang="stylus">
    a.botao-visualisar-propostas *
        background-color transparent

    a.botao-visualisar-propostas
        margin-left 10px
        min-width 50px
        font-size 13px
        display block

    a.deshabilidato
        pointer-events none


    .primary-color
        color var(--v-primary-lighten1) !important

    .secondary-color
        color var(--v-primary-lighten1) !important

    i
        font-size 13px
        top 0

</style>
